<template>
  <div>
    <slot v-bind:open="open" />

    <Modal :show="show" @closeModal="close" size="lg">

      <h1 class="text-xl">
        Order #{{ note.order_id }} - Note #{{ note.id }} - Handover to Customer
      </h1>
      <div class="py-5">
        <div class="-mx-4 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
            <tr class="divide-x divide-gray-300">
              <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Item Code</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Description</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
                Quantity
              </th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Unit</th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-300">
            <tr v-for="(item, index) in form.items" :key="'note-'+note.id+'-item-'+item.id" class="divide-x divide-gray-300">
              <td class="relative py-4 pl-4 pr-3 text-sm sm:pl-6">
                {{ item.item_code }}
              </td>
              <td class="px-3 py-3.5 text-sm text-gray-500 lg:table-cell">
                {{ item.description }}
              </td>
              <td class="px-3 py-1 text-sm text-gray-500 text-left">
                <div class="flex items-center gap-x-2">
                  <div class="w-16">
                    <FormInput
                      type="number"
                      v-model.number="item.quantity_handover"
                      class="py-1"
                      :errors="getError(index, 'quantity_handover')"
                      state
                    />
                  </div>
                </div>
              </td>
              <td class="px-3 py-3.5 text-sm text-gray-500 lg:table-cell">
                {{ item.unit }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="flex w-full justify-end gap-x-3">
        <button @click="close" class="btn-gray">Cancel</button>
        <LoadingButton
          v-if="canProceed"
          class="btn-primary"
          :loading="form.processing"
          :disabled="form.processing"
          @click="proceedHandoverToCustomer"
        >
          Proceed
        </LoadingButton>
      </div>
    </Modal>
  </div>
</template>

<script>
import Dialog from "@/Shared/Dialog.vue";
import FormInput from "@/Shared/Form/FormInput.vue";
import {cloneDeep} from "lodash";
import Modal from "@/Shared/Modal.vue";
import LoadingButton from "@/Shared/LoadingButton.vue";

export default {
  name: 'HandoverToCustomerModal',
  components: {LoadingButton, Modal, FormInput, Dialog},

  props: {
    note: Object,
    items: Array,
    canHandoverItemsToCustomer: Boolean,
    handoverRoute: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      show: false,
      form: this.$inertia.form({
        type: this.note.type,
        items: [],
      })
    }
  },

  computed: {
    getError() {
      return (index, fieldName) => {
        const errorKey = `items.${index}.${fieldName}`;
        if (Object.keys(this.form.errors).length) {
          return this.form.errors[errorKey];
        }
        return []
      }
    }
  },

  methods: {
    open() {
      const items = cloneDeep(this.items)
      this.form.items = items.filter(itm => !itm.delivered)
        .filter(itm => itm.quantity_handover - itm.quantity_delivered || 0 < itm.quantity_assigned)
      setTimeout(() => {
        this.show = true;
      }, 250)
    },
    close() {
      this.show = false
      this.$emit('close')
      setTimeout(() => this.form.reset(), 200)
    },

    canIssueItems() {
      if (this.note.type === 'collection') {
        return this.canHandoverItemsToCustomer && (this.note.status === 'pending' || this.note.status === 'in-progress')
      } else {
        return this.note.status === 'in-progress'
      }
    },

    proceedHandoverToCustomer() {
      if (this.canIssueItems()) {
        this.form.post(this.handoverRoute, {
          onSuccess: () => this.close(),
          preserveState: 'error',
        })
      }
    },

    canProceed() {
      if (this.canHandoverItemsToCustomer) {
        return this.form.items.length > 0
      }

    }
  }
}
</script>
